import EasyApplyFormComponent from '../../components/EasyApplyForm/EasyApplyForm'

const EasyApplyForm = () => {
  return (
    <div>
        <EasyApplyFormComponent />
    </div>
  )
}

export default EasyApplyForm